import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Avatar,
  Card,
  Container,
  Stack,
  Chip,
  CircularProgress,
  Tooltip,
  Link as MuiLink,
} from "@mui/material";
import {
  Edit as EditIcon,
  Add as AddIcon,
  Store as StoreIcon,
  Launch as LaunchIcon,
} from "@mui/icons-material";
import { apiUrl } from "../../comp/ApiUrl";

const Lojas = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Lojas | FazPedido";
    fetchLojas();
  }, []);

  const fetchLojas = async () => {
    try {
      const response = await fetch(`${apiUrl}/lojas`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userToken"),
        },
      });
      if (response.ok) {
        const result = await response.json();
        setData(result);
      }
    } catch (error) {
      console.error("Erro ao carregar lojas:", error);
    } finally {
      setLoading(false);
    }
  };

  // Função para renderizar o status de forma colorida
  const renderSituacao = (situacao) => {
    const isAtivo = situacao?.toLowerCase() === "ativo";
    return (
      <Chip
        label={situacao || "---"}
        color={isAtivo ? "success" : "default"}
        variant="outlined"
        size="small"
      />
    );
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ py: 4, backgroundColor: "#f4f6f8", minHeight: "100vh" }}>
      <Container maxWidth="xl">
        {/* Cabeçalho da Página */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 4 }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <StoreIcon color="primary" sx={{ fontSize: 32 }} />
            <Typography variant="h4" component="h1" fontWeight="700">
              Lojas
            </Typography>
          </Box>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            component={Link}
            to="cadastro"
            sx={{ borderRadius: 2, textTransform: "none", px: 3 }}
          >
            Cadastrar Loja
          </Button>
        </Stack>

        {data.length === 0 ? (
          <Paper sx={{ p: 5, textAlign: "center", borderRadius: 2 }}>
            <Typography variant="h6" color="text.secondary">
              Nenhuma loja encontrada. Comece cadastrando uma nova!
            </Typography>
          </Paper>
        ) : (
          <TableContainer
            component={Paper}
            elevation={0}
            sx={{ borderRadius: 2, border: "1px solid #e0e0e0" }}
          >
            <Table sx={{ minWidth: 700 }}>
              <TableHead sx={{ backgroundColor: "#f9fafb" }}>
                <TableRow>
                  <TableCell width={100}>Logo</TableCell>
                  <TableCell>Nome</TableCell>
                  <TableCell>Endereço</TableCell>
                  <TableCell>Domínio Web</TableCell>
                  <TableCell align="center">Situação</TableCell>
                  <TableCell align="center">Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((loja) => (
                  <TableRow key={loja.id} hover>
                    <TableCell>
                      <Avatar
                        src={`${apiUrl}/static/${loja.imagem}`}
                        alt={loja.nome}
                        variant="rounded"
                        sx={{ width: 60, height: 60, border: "1px solid #eee" }}
                      >
                        <StoreIcon />
                      </Avatar>
                    </TableCell>
                    <TableCell>
                      <Typography variant="subtitle2" fontWeight="600">
                        {loja.nome}
                      </Typography>
                    </TableCell>
                    <TableCell
                      sx={{ color: "text.secondary", fontSize: "0.875rem" }}
                    >
                      {`${loja.rua}, ${loja.numero}`} <br />
                      {`${loja.bairro} - ${loja.cidade}`}
                    </TableCell>
                    <TableCell>
                      <MuiLink
                        href={`https://${loja.dominio}.fazpedido.app`}
                        target="_blank"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                          fontSize: "0.875rem",
                        }}
                        underline="hover"
                      >
                        {loja.dominio}.fazpedido.app
                        <LaunchIcon sx={{ fontSize: 14 }} />
                      </MuiLink>
                    </TableCell>
                    <TableCell align="center">
                      {renderSituacao(loja.situacao)}
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title="Editar Loja">
                        <IconButton
                          component={Link}
                          to={`/loja/${loja.token}/editar`}
                          color="primary"
                          sx={{
                            backgroundColor: "#e3f2fd",
                            "&:hover": { backgroundColor: "#bbdefb" },
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Container>
    </Box>
  );
};

export default Lojas;
